import React from 'react';
import {connect} from "react-redux";
import AuthErrorComponent from "../components/AuthErrorComponent";
import "../style/auth-error.css";
import logo from "../img/logo.png";

class AuthenticationError extends React.Component {

    render() {
        return this.props.authenticationError ?
            <div className="content container-fluid auth-error">
                    <img src={logo} alt="Proximus" />
                    <div >
                        <AuthErrorComponent onRetryClicked={() => this.props.login()} message={this.props.message} stack={this.props.stack}/>
                    </div>

            </div>
            : null;
    }

}

export default connect(
    (state) => {
        return {
            authenticationError: state.oidc.error,
            message: state.oidc.errorMessage,
            stack: state.oidc.errorStack
        }
    },
    (dispatch) => {
        return {
            login: () => {
                dispatch({
                    type: 'LOGIN'
                })
            }
        }
    }
)(AuthenticationError)
